import React from 'react';

import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';

import checkIcon from '../../assets/job-post-promo-check.svg';
import arrowIcon from '../../assets/job-post-promo-arrow.svg';
import matchCheckIcon from '../../assets/job-post-promo-match-check.svg';
import avatar1 from '../../assets/job-post-promo-avatar-1.png';
import avatar2 from '../../assets/job-post-promo-avatar-2.png';
import avatar3 from '../../assets/job-post-promo-avatar-3.png';
import css from './AdvertiseProjectsCard.css';

const MATCH_AVATARS = [avatar1, avatar2, avatar3];

const AdvertiseProjectsCard = props => {
  const {
    className,
    rootClassName,
    onSetSignUpFrom,
    onSetSignUpFromPath,
    history,
    currentUser,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const userIsLoggedIn = !!currentUser?.id;
  const isCustomer = currentUser?.attributes?.profile?.publicData?.account_role === 'customer';

  const handleOpenChat = () => {
    if (typeof window === 'object') {
      if (userIsLoggedIn) {
        history.push('/pl/new');
      } else {
        onSetSignUpFrom(onSetSignUpFromPath);
        history.push('/tyoilmoitus');
      }
    }
  };

  if (userIsLoggedIn && !isCustomer) {
    return null;
  }

  return (
    <div className={classes}>
      <div className={css.cardContent}>
        <div className={css.textContent}>
          <div className={css.cardTitle}>
            <FormattedMessage id="AdvertiseProjectsCard.title" />
          </div>
          <div className={css.cardDescription}>
            <FormattedMessage id="AdvertiseProjectsCard.description" />
          </div>
        </div>
        <ul className={css.pills}>
          <li className={css.pill}>
            <img src={checkIcon} alt="" className={css.pillIcon} />
            <FormattedMessage id="AdvertiseProjectsCard.pill1" />
          </li>
          <li className={css.pill}>
            <img src={checkIcon} alt="" className={css.pillIcon} />
            <FormattedMessage id="AdvertiseProjectsCard.pill2" />
          </li>
        </ul>
        <div className={css.matches} aria-hidden="true">
          {MATCH_AVATARS.map(src => (
            <img key={src} src={src} alt="" width="40" height="40" className={css.matchAvatar} />
          ))}
          <span className={css.matchCheck}>
            <img src={matchCheckIcon} alt="" className={css.matchCheckIcon} />
          </span>
        </div>
      </div>
      <button type="button" className={css.ctaButton} onClick={handleOpenChat}>
        <FormattedMessage id="AdvertiseProjectsCard.ctaButton" />
        <img src={arrowIcon} alt="" className={css.ctaArrow} />
      </button>
    </div>
  );
};

export default injectIntl(AdvertiseProjectsCard);
